"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientHealthCareParty = void 0;
/**
 * One or several periods of care by an hcp for this patient
 */
class PatientHealthCareParty {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.PatientHealthCareParty = PatientHealthCareParty;
(function (PatientHealthCareParty) {
    PatientHealthCareParty.TypeEnum = {
        Doctor: 'doctor',
        Referral: 'referral',
        Medicalhouse: 'medicalhouse',
        Retirementhome: 'retirementhome',
        Hospital: 'hospital',
        Other: 'other',
        Referringphysician: 'referringphysician',
        ReferralHospital: 'referralHospital',
    };
})(PatientHealthCareParty = exports.PatientHealthCareParty || (exports.PatientHealthCareParty = {}));
//# sourceMappingURL=PatientHealthCareParty.js.map